/** @jsx jsx */
import { jsx, Card, Box, Text, Grid, Flex, Button, Heading } from 'theme-ui';
import React, { useState, useEffect } from 'react'
import Layout from '../../components/layout';
import Hero from '../../components/hero'
import { responsive } from '../../utils/helpers'
import Wrapper from '../../components/layout/wrapper'
import Inner from '../../components/layout/inner'
import LineUp from '../../components/lineup/opta'
import Statistic from '../../components/statistic/opta'
import { Powered } from '../../components/footer'
import { Player } from '../../components/video'
import Versus from '../../components/versus';
import { getCurrentMatch } from '../../api/opta'
import Article from '../../components/article'
import Modal, { Overlay, Close } from '../../components/modal'
import { getIdToken } from '../../utils/auth'
import StreamAMG from '../../api/streamAmg'
import { VoucherForm, Player as StreamPlayer } from '../../components/liveStream'
import styles from './page.styles'

const Page = (props) => {

  const [kSession, setKSession] = useState()
  const [currentMatch, setCurrentMatch] = useState()
  const [showPackages, setShowPackages] = useState(false)
  const [packages, setPackages] = useState()

  useEffect(() => {
    (async () => {

      const match = await getCurrentMatch();
      if (!match.success)
        return
      setCurrentMatch(match.data)
    })()
  }, [
    setCurrentMatch
  ])

  useEffect(() => {
    (async () => {
      if (packages)
        return

      const idToken = await getIdToken();
      const streamAMG = new StreamAMG({
        jwtToken: idToken ? idToken : null,
        language: 'en'
      })

      streamAMG.getSubscriptionPackageList(null, (data) => {
        console.log('packages', data);
        setPackages(data?.SubscriptionPlanOptions)
      })
    })()
  }, [
    packages
  ])

  const handleStreamClick = async () => {
    const idToken = await getIdToken();
    const streamAMG = new StreamAMG({
      jwtToken: idToken ? idToken : null,
      language: 'en'
    })
    streamAMG.getKSession({entryid: props.kSessionId}, (data) => {
      console.log(`K Session`, data);
      if (data.KSession) {
        setKSession(data.KSession)
      } else {
        setShowPackages(true)
      }
    })
  }

  const Packages = () => {
    if (!packages || !Array.isArray(packages))
      return null

    return packages.map((x,i) => {
      return (
        <Card variant="slim" mb={2} key={i}>
          <Box p={4} sx={{textAlign: 'center'}} key={i}>
            <Text pb={2}>{x.Title}</Text>
            <Box pb={2} dangerouslySetInnerHTML={{__html: x.Body}} />
            <Button as="a" href={x.PurchaseUrl}>Buy</Button>
          </Box>
        </Card>
      )
    })
  }

  const page = props.pageData

  const NoMatchHeader = () => {

    return (
      <Box sx={styles.header}>
        <Heading variant="heading" sx={styles.heading}>{props.title}</Heading>
        <Flex sx={styles.subheading} mb={3}>Add <Text mx={1} sx={styles.bold}>FGR LIVE access</Text> to your account to get full access to FGR Live streaming.</Flex>
        <Button onClick={handleStreamClick}>{props.cta}</Button>
      </Box>
    )
  }

  return (
    <Layout {...props} light={page?.theme === 'light'}>
      <Hero
        back='/match-centre/fgr-live'
        data={[
          {
            type: 'Custom',
            backgroundImage: {file: { url: props.background} },
            children: (
              currentMatch ?
                <Versus
                  fixtureData={currentMatch}
                  title={props.title}
                  variant="large"
                  buttons={<Button onClick={handleStreamClick}>{props.cta}</Button>}
                />
              : <NoMatchHeader />
            )
          }
        ]}
      />

      <Wrapper>
        <Inner>
          {currentMatch &&
            <Grid columns={responsive(1, 2)} gap={4} mt={8} mb={4}>
              <Card variant="slim">
                <Text variant="banner">Line-ups</Text>
                <Box p={4}>
                  <Versus
                    variant="tiny"
                    color="black"
                    fixtureData={currentMatch}
                    sx={{mb: 4}}
                  />
                  <LineUp data={currentMatch} />
                </Box>
              </Card>
              <Card variant="slim">
                <Text variant="banner">Statistics</Text>
                <Box p={4}>
                  <Versus
                    variant="tiny"
                    color="black"
                    fixtureData={currentMatch}
                  />
                  <Box pt={3} pb={3} pl={8} pr={8}>
                    <Statistic optaFixtureId={currentMatch.matchInfo?.id} />
                  </Box>
                </Box>
              </Card>
            </Grid>
          }
          {!currentMatch &&
            <Box my={10}>
              <Article {...page.subscribeArticle} />
            </Box>
          }
          <Powered />
        </Inner>
      </Wrapper>

      {kSession &&
        <Player onClose={() => setKSession(false)}>
          <StreamPlayer
            id={props.kSessionId}
            ksession={kSession}
          />
        </Player>
      }

      {showPackages &&
        <React.Fragment>
          <Overlay onClick={() => setShowPackages(false)} />
          <Close onClick={() => setShowPackages(false)} />
          <Modal sx={{width: responsive('90%', '600px')}} scrollToTop>
            <VoucherForm />
            <Packages />
          </Modal>
        </React.Fragment>
      }


    </Layout>
  )
}

export default Page;
